import {useMutation} from '@tanstack/react-query';
import WeddingsApi from '../services/WeddingsApi';

const useSetWeddingGuestCount = () =>
  useMutation(async ({memberId, guestCount: guestRange}) =>
    WeddingsApi.updateWedding(memberId, guestRange),
  );

export default useSetWeddingGuestCount;
